module.exports = __webpack_public_path__ + "img/info.81c8152b.svg";